import { captureException } from '@sentry/browser';
import { StorageWrapper } from './StorageWrapper';

export const tryFetchLocalStorage = () => {
  try {
    return window.localStorage;
  } catch (err) {
    let msg = err.message;
    if (err.name === 'SecurityError') {
      msg += ' Cookies are most likely disabled on the browser.';
    }
    const e = new Error(msg);
    e.stack = err.stack;
    e.name = 'LocalStorageFetchError';
    captureException(e);
    console.error('Error fetching local storage object', msg);
    return null;
  }
};

export const LocalStorage = StorageWrapper.create(() => tryFetchLocalStorage());
